<template>
  <div>
    <div class="card card-custom gutter-b">
      <notifications group="notification" position="bottom right" />

      <!--begin::Header-->
      <div class="card-header border-0 py-5">
        <h3 class="card-title">
          <span class="card-label font-weight-bolder text-dark">Regions</span>
        </h3>
        <div class="card-toolbar">
          <!--begin::Button-->
          <router-link
            to="/regions/new"
            class="btn btn-primary font-weight-bolder"
          >
            <span class="svg-icon svg-icon-md">
              <inline-svg src="media/svg/icons/Design/Select.svg" />
            </span>
            New Region
          </router-link>
          <!--end::Button-->
        </div>
      </div>
      <!--end::Header-->
      <!--begin::Body-->
      <div class="card-body pt-0 pb-3">
        <!--begin::Table-->
        <div v-if="isLoaded" class="table-responsive">
          <table
            class="table table-head-custom table-head-bg table-vertical-center table-borderless"
          >
            <thead>
              <tr class="bg-gray-100 text-left">
                <th style="min-width: 250px" class="pl-7">
                  <span @click="orderByName" class="cursor-pointer">
                    <span
                      class="pt-2"
                      :class="{ 'text-primary': nameOrder.isActive }"
                    >
                      Title</span
                    >
                    <span
                      class="svg-icon svg-icon-sm  pl-2"
                      :class="{
                        'svg-icon-primary': nameOrder.isActive
                      }"
                    >
                      <inline-svg
                        v-if="nameOrder.query === 'asc'"
                        src="media/svg/icons/Navigation/Down-2.svg"
                      />
                      <inline-svg
                        v-else
                        src="media/svg/icons/Navigation/Up-2.svg"
                      />
                    </span>
                  </span>
                </th>
                <th style="min-width: 110px" class="text-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="region in regions" :key="region.id">
                <td class="pl-7 py-2">
                  <div class="d-flex align-items-center">
                    <div>
                      <router-link
                        :to="'/regions/edit/' + region.id"
                        class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
                      >
                        {{ region.title }}
                      </router-link>
                      <span class="text-muted font-weight-bold d-block">
                        <div>
                          <strong>Created: </strong
                          ><span>{{
                            region.createdAt | moment('DD.MM.YYYY')
                          }}</span>
                        </div>
                      </span>
                    </div>
                  </div>
                </td>
                <td class="pr-7 text-right">
                  <router-link
                    :to="'/regions/edit/' + region.id"
                    class="btn btn-sm btn-default btn-text-primary btn-hover-primary btn-icon mr-2"
                  >
                    <span class="svg-icon svg-icon-md">
                      <inline-svg src="media/svg/icons/Design/Edit.svg" />
                    </span>
                  </router-link>
                  <router-link
                    :to="{
                      name: 'regions-edit-translations',
                      params: { id: region.id }
                    }"
                    class="btn btn-sm btn-default btn-text-primary btn-hover-primary btn-icon mr-2"
                  >
                    <span class="svg-icon svg-icon-md">
                      <inline-svg
                        src="media/svg/translate.svg"
                        title="Edit Translations"
                        aria-label="Edit Translations"
                      />
                    </span>
                  </router-link>
                  <button
                    @click="removeEntity(region.id)"
                    class="btn btn-sm btn-default btn-text-primary btn-hover-primary btn-icon"
                  >
                    <span class="svg-icon svg-icon-md">
                      <inline-svg src="media/svg/icons/General/Trash.svg" />
                    </span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--end::Table-->
        <div v-else class="w-100 d-flex justify-content-center my-10">
          <div class="d-flex align-items-center">
            <div class="mr-2 text-muted">Loading...</div>
            <div class="spinner spinner-primary mr-10"></div>
          </div>
        </div>
      </div>
      <!--end::Body-->
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module'
import ApiService from '@/core/services/api.service'

export default {
  data() {
    return {
      regions: [],
      nameOrder: {
        query: 'asc',
        isActive: false
      },
      isLoaded: false,
      imagePath: process.env.VUE_APP_ROUTE_API_URL
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: 'Regions' }])

    // get all regions
    ApiService.get(
      'regions',
      '?order[translations.title]=asc&itemsPerPage=100'
    ).then(({ data }) => {
      this.regions = [...data['hydra:member']]
      this.isLoaded = true
    })
  },
  methods: {
    async deleteEntity(id) {
      try {
        return await ApiService.delete('regions/' + id)
      } catch (e) {
        throw new Error(e)
      }
    },
    orderByName() {
      this.isLoaded = false
      this.regions = []
      this.nameOrder.isActive = true
      this.nameOrder.query = this.nameOrder.query === 'asc' ? 'desc' : 'asc'

      ApiService.get(
        'regions',
        `?order[translations.title]=${this.nameOrder.query}&itemsPerPage=100`
      ).then(({ data }) => {
        this.regions = [...data['hydra:member']]
        this.isLoaded = true
      })
    },
    removeEntity(id) {
      const confirmation = confirm('Are you sure?')
      if (confirmation === false) return

      this.deleteEntity(id).then(({ status }) => {
        if (status === 204) {
          this.regions = this.regions.filter(region => region.id !== id)
          this.$notify({
            group: 'notification',
            type: 'error',
            title: 'Region deleted'
          })
        }
      })
    }
  }
}
</script>
